'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function livePresenceService($window, $q, $log, $http, $interval, $rootScope, livePresenceSharePointConstants, livePresenceSitecoreConstants, EnvironmentService) {
    var vm = this;

    //functions
    vm.init = init;

    //function for appending script tag to body
    function scriptLoader(src) {
        var s = $window.document.createElement('script');
        s.src = src || (EnvironmentService.isSitecore() ? livePresenceSitecoreConstants : livePresenceSharePointConstants).SCRIPT;
        $window.document.body.appendChild(s);
    }

    //loading json based on give source, config and environment
    function jsonLoader(src, config, env) {
        if (config.indexOf('-') > -1) {
            config = config.substring(0, config.indexOf('-'));
        }

        $http.get(src).success(function (res) {
            if (angular.isObject(res[config])) {
                var data = res[config];

                //URL's voor environment verwerken
                if (data.ENV[env] !== undefined) {
                    angular.forEach(data.ENV[env], function (value, key) {
                        $window[key] = value;
                    });
                } else {
                    $log.error('Invalid ENV:', env);
                }
            }
        }).error(function () {
            $log.warn('LivePresenceResource: Could not retrieve ' + src + ' data');
        });
    }

    // set config vars to window and load json
    function setConfig(config, env, resourceSrc) {
        var livePresenceConstants = EnvironmentService.isSitecore() ? livePresenceSitecoreConstants : livePresenceSharePointConstants;

        if (livePresenceConstants.CONFIG[config] !== undefined) {
            angular.forEach(livePresenceConstants.CONFIG[config], function (value, key) {
                $window[key] = value;
            });

            if (livePresenceConstants.RESOURCE !== undefined) {
                jsonLoader(resourceSrc || livePresenceConstants.RESOURCE, config, env);
            } else {
                $log.error('Constant: RESOURCE not present');
            }
        } else {
            $log.error('Invalid config:', config);
        }
    }

    function init(config, env, scriptSrc, resourceSrc) {
        var deferred = $q.defer();

        if ($window.gWebClient === undefined) {
            setConfig(config, env, resourceSrc);
            watchStarted();

            $window.initialize = function () {
                deferred.resolve();
            };

            if ($window.document.readyState === 'complete') {
                scriptLoader(scriptSrc);
            } else {
                if ($window.attachEvent) {
                    $window.attachEvent('onload', function () {
                        scriptLoader(scriptSrc);
                    });
                } else {
                    $window.addEventListener('load', function () {
                        scriptLoader(scriptSrc);
                    }, false);
                }
            }
        } else {
            // already loaded
            deferred.resolve();
        }

        return deferred.promise;
    }

    function watchStarted() {
        var interval = $interval(function () {
            //Make sure live presence script is loaded and available for input, before enabling the virtuele assistent
            if (typeof gWebClient !== 'undefined' && gWebClient !== null && gWebClient.HasStarted) {
                $rootScope.$broadcast('livechat-ready');
                $interval.cancel(interval);
            }
        }, 500, 100); //Cancel interval after 100 * 100ms = 10000ms = 50 seconds
    }
}

livePresenceService.$inject = ['$window', '$q', '$log', '$http', '$interval', '$rootScope', 'livePresenceSharePointConstants', 'livePresenceSitecoreConstants', 'EnvironmentService'];

exports.default = livePresenceService;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/chat/live-presence.service.js
// module id = 875
// module chunks = 0